import {Button, FlexContainer, H1Text, H2Text} from "../../../../../design";
import {Col, Row} from "react-awesome-styled-grid";
import {AmountDivideByHundred} from "../../../../../helper";
import DownloadIcon from "../../../../../assets/imgs/download.svg";
import SmallScreenView from "../../../../../components/smallscreen";
import React from "react";
import currencyFormatter from "../../../../../utils/currencyformatter";

type Props = {
  invoice: Object,
  download: Function,
  history: {
    push: Function,
  },
}

const InvoiceHeader = (props:Props) => {
  const {invoice, download, history} = props;
  const {location: { pathname }} = history;

  const getTotalAmount = () => {
    return invoice && invoice.total;
  };

  return (
    <SmallScreenView sm xs>
      <FlexContainer
        display="block"
        borderRadius="3px"
        boxShadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
        className="text-center p-2 py-3 mx-1 mt-2 bg-white"
      >
        <Row className="w-100 px-2 align-items-center">
          <Col xs={2} sm={4} className="align-items-start">
            <H2Text fontSize="16px" className="mb-0 align-items-center">Total Amount </H2Text>
            <H1Text className="mb-0 align-items-center pt-2">
              {invoice && invoice.currency && currencyFormatter(AmountDivideByHundred(getTotalAmount()), invoice.currency.name)}
            </H1Text>
          </Col>
          <Col xs={2} sm={4} className="align-items-end">
            <span className="align-items-center d-flex">
              <img style={{cursor: "pointer"}} onClick={download} src={DownloadIcon} className="px-4" alt={""}/>
              <Button hidden={invoice && (invoice.status === "PAID" || invoice.status === "CANCELLED")} onClick={() => props.history.push(`${pathname}/pay`)} type="primary" border="1px solid #40a9ff !important" borderRadius="50px" className="px-4 py-2">
                <span>PAY</span><span className="d-none d-sm-inline">&nbsp;NOW</span>
              </Button>
            </span>
          </Col>
        </Row>
      </FlexContainer>
    </SmallScreenView>
  )
};

export default InvoiceHeader
